import { Paper } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { DataGridPro, GRID_CHECKBOX_SELECTION_COL_DEF, GridColDef } from '@mui/x-data-grid-pro';
import { HeaderCell } from '../../common/components/Cells/HeaderCell';
import { CustomNoRowsOverlay } from '../../common/components/CustomNoRowsOverlay';
import { dataGridStyleOverrides as globalDataGridStyleOverrides } from '../../common/style/data-grid-styles';
import { User } from '../models/User';

type Props = {
  noRowsLabel: string;
  header: string;
  loading?: boolean;
  onSelectionChange: (ids: number[]) => void;
  rows: User[];
  selectedRows?: number[];
  disabled?: boolean;
};

export const UsersSelectTable = ({ noRowsLabel, header, loading = false, onSelectionChange, rows, selectedRows, disabled }: Props) => {
  const columns: GridColDef<User>[] = [
    {
      field: 'name',
      flex: 1,
      sortable: false,
      filterable: false,
      headerName: header,
      renderHeader: () => <HeaderCell label={header} />,
      valueGetter: ({ row }) => row.getPreferredName() || row.getName(),
    },
  ];

  const handleSelectionChange = (selectedIds: number[]) => {
    onSelectionChange(selectedIds);
  };

  const style = deepmerge({ opacity: disabled ? 0.6 : 1 }, globalDataGridStyleOverrides);

  return (
    <Paper sx={{ height: '100%' }}>
      <DataGridPro
        // hide the checkbox state, we can get the column field key from GRID_CHECKBOX_SELECTION_COL_DEF
        initialState={{
          columns: {
            columnVisibilityModel: {
              [GRID_CHECKBOX_SELECTION_COL_DEF.field]: false,
            },
          },
        }}
        columns={columns}
        disableRowSelectionOnClick={disabled}
        hideFooter
        checkboxSelection // isMultiselect
        loading={loading}
        slots={{ noRowsOverlay: () => <CustomNoRowsOverlay label={noRowsLabel} /> }}
        onRowSelectionModelChange={(selectedIds) => handleSelectionChange(selectedIds as number[])}
        getRowClassName={() => (disabled ? '' : 'clickable')}
        rows={rows}
        rowSelectionModel={selectedRows}
        disableColumnMenu
        disableVirtualization
        sortingMode={'server'}
        sx={style}
        experimentalFeatures={{ ariaV7: true }}
      />
    </Paper>
  );
};
